import { render, staticRenderFns } from "./UIQuote.vue?vue&type=template&id=beea5146&"
import script from "./UIQuote.vue?vue&type=script&lang=js&"
export * from "./UIQuote.vue?vue&type=script&lang=js&"
import style0 from "./UIQuote.vue?vue&type=style&index=0&id=beea5146&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beea5146')) {
      api.createRecord('beea5146', component.options)
    } else {
      api.reload('beea5146', component.options)
    }
    module.hot.accept("./UIQuote.vue?vue&type=template&id=beea5146&", function () {
      api.rerender('beea5146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UIQuote.vue"
export default component.exports